import type { Project } from '../types/index.tsx';

type ReportUrlType = {
	baseUrl: string;
	project: Partial<Project>;
};
export const createReportUrlFunc =
	({ baseUrl, project }: ReportUrlType) =>
	(reportKey: string) =>
		`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;
